
import { formatInTimeZone } from "date-fns-tz";

export const formatDate = (dateString: string, includeTime: boolean = false) => {
  return formatInTimeZone(
    new Date(dateString),
    'Australia/Sydney',
    includeTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'
  );
};
